import styled from "styled-components";
import { createShouldForwardPropBlockList } from "../utils/helper";

type ContentProps = {
    width?: number;
};

export const Wrapper = styled("div")(() => ({
    position: "relative",
}));

export const Input = styled("div")(() => ({
    position: "relative",
}));

export const Content = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["width"]),
})<ContentProps>(({ width }) => ({
    position: "absolute",
    top: "100%",
    left: 0,
    zIndex: "100",
    ...(width && {
        width: width,
    }),
}));

export const Body = styled("div")(({ theme }) => ({
    marginTop: "5px",
    background: theme.colors.white,
    boxShadow: theme.boxShadow.DEFAULT,
    borderRadius: theme.borderRadius.lg,
    width: "100%",
}));
